// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured_featured__1nWid","featuredMobile":"Featured_featuredMobile__29QLw","box":"Featured_box__3quGR","eachItem":"Featured_eachItem__1M5Un"};